// Reads jobs through this site's /api/jobs edge function (SEC-003) instead of querying Sanity
// from the browser, so the dataset can be private. Same shape as before: client.fetch(request)
// resolves to the query result, and rejects on errors (callers already handle that).
async function fetchJobs(request) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(request)) {
    if (value !== undefined && value !== null) params.set(key, String(value));
  }
  const res = await fetch(`/api/jobs?${params}`);
  if (!res.ok) throw new Error(`jobs api ${res.status}`);
  const body = await res.json();
  return body.result;
}

export const client = { fetch: fetchJobs };
